var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bk-choice" },
    [
      _c("bk-input-label", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bk-choice__list" },
        _vm._l(_vm.choices, function(choice) {
          return _c("div", { staticClass: "bk-choice__item" }, [
            _c("input", {
              attrs: {
                id: _vm.getId(choice.id),
                name: _vm.name,
                type: "radio"
              },
              domProps: {
                checked: _vm.value === choice.value,
                value: choice.value
              },
              on: {
                input: function($event) {
                  return _vm.$emit("input", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "bk-choice__item__label",
                attrs: { for: _vm.getId(choice.id) }
              },
              [_vm._v(_vm._s(choice.text))]
            )
          ])
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }